import { c as _c } from "react/compiler-runtime";
import { Tooltip } from '@mui/material';
import type { ComplianceStatus, ConfigurationStatus, ControlViolations } from '@repo/api-gw-sdk';
import { ControlViolationsTooltip } from '@/components/controls/controlIndicator';
import { ComplianceStatuses, ConfigurationStatuses } from '@/data/inventory/data';
import { ResourceStatusIcon } from './resourceStatusBadge';

// Both columns show the icon alone and name the status on hover, so a row reads as a row of
// indicators rather than three columns of prose competing with the resource name.

export const ConfigurationStatusBadge = t0 => {
  const $ = _c(7);
  const {
    status
  } = t0;
  const look = status ? ConfigurationStatuses[status] : undefined;
  if (!look) {
    return null;
  }
  let t1;
  if ($[0] !== look.backgroundColor || $[1] !== look.icon || $[2] !== look.iconColor) {
    t1 = <ResourceStatusIcon icon={look.icon} iconColor={look.iconColor} backgroundColor={look.backgroundColor} />;
    $[0] = look.backgroundColor;
    $[1] = look.icon;
    $[2] = look.iconColor;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== look.name || $[5] !== t1) {
    t2 = <Tooltip title={look.name}>{t1}</Tooltip>;
    $[4] = look.name;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};

// The compliance verdict is a reading of the resource's violations, so its tooltip carries the same
// severity breakdown the backup status hangs off its own icon.
export const ComplianceStatusBadge = t0 => {
  const $ = _c(8);
  const {
    status,
    controlViolations
  } = t0;
  const look = status ? ComplianceStatuses[status] : undefined;
  if (!look) {
    return null;
  }
  let t1;
  if ($[0] !== look.backgroundColor || $[1] !== look.icon || $[2] !== look.iconColor) {
    t1 = <ResourceStatusIcon icon={look.icon} iconColor={look.iconColor} backgroundColor={look.backgroundColor} />;
    $[0] = look.backgroundColor;
    $[1] = look.icon;
    $[2] = look.iconColor;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== controlViolations || $[5] !== look.name || $[6] !== t1) {
    t2 = <ControlViolationsTooltip title={look.name} controlViolations={controlViolations}>{t1}</ControlViolationsTooltip>;
    $[4] = controlViolations;
    $[5] = look.name;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
};